export default __webpack_public_path__ + "static/media/apps_profono_acesso.b8263814.png";